const styles = (theme) => ({
  SharedLookLimitButtonWrapper: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    maxWidth: 600,
    zIndex: 122,
    padding: theme.spacing(1.25, 2.5),
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: theme.color.red_00,
    color: theme.color.white,
    borderRadius: theme.spacing(1.25),
  },
  itemLink: {
    fontSize: 16,
    fill: theme.color.white,
    width: '65%',
  },
  whiteColor: {
    fill: theme.color.white,
  },
});

export default styles;
